import { useEffect, useState } from "react";

/**
 * A seção que está sendo lida: a última cujo topo já passou da faixa logo
 * abaixo do header fixo. Alimenta o destaque do índice.
 */
export const useActiveSection = (ids: string[]) => {
  const [active, setActive] = useState(ids[0]);

  useEffect(() => {
    const elements = ids
      .map(id => document.getElementById(id))
      .filter((element): element is HTMLElement => element !== null);
    if (!elements.length) return;

    // Faixa de leitura: de 120px (abaixo do header) até 60% da altura da tela.
    const observer = new IntersectionObserver(
      entries => {
        const visible = entries
          .filter(entry => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      },
      { rootMargin: "-120px 0px -40% 0px" }
    );
    elements.forEach(element => observer.observe(element));
    return () => observer.disconnect();
  }, [ids]);

  return active;
};
